module.exports = __webpack_public_path__ + "static/media/TAGGIS-Promo-2022.e097bba6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/TAGGIS-Promo-2022.pdf
// module id = 465
// module chunks = 3